const API_DOMAIN = process.env.REACT_APP_API_DOMAIN;

export default API_DOMAIN;
